import { gql } from 'apollo-boost';

export const getPageLinksQuery = gql`
  query {
    Links {
      id
      title
      url
      createDate
      logoName
      token
      shortLinkUrl
      totalHit
      isVisible
    }
  }
`;

export const getPagePreviewLinkQuery = gql`
  query LinksPreview($pageName: String!) {
    LinksPreview(input: { pageName: $pageName }) {
      id
      title
      url
      logoName
      shortLinkUrl
    }
  }
`;

export const generateNewShortLinkQuery = gql`
  mutation GenerateNewShortLink {
    GenerateNewShortLink {
      token
    }
  }
`;

export const newLinkQuery = gql`
  mutation NewLink(
    $logoName: String!
    $title: String!
    $url: String!
    $shortLink: String!
  ) {
    NewLink(
      input: {
        logoName: $logoName
        title: $title
        url: $url
        shortLink: $shortLink
      }
    ) {
      id
      title
      url
      createDate
      logoName
      token
      shortLinkUrl
      totalHit
      isVisible
    }
  }
`;

export const editLinkQuery = gql`
  mutation EditLink(
    $id: ID!
    $logoName: String!
    $title: String!
    $url: String!
    $shortLink: String!
  ) {
    EditLink(
      input: {
        id: $id
        logoName: $logoName
        title: $title
        url: $url
        shortLink: $shortLink
      }
    ) {
      id
      title
      url
      createDate
      logoName
      token
      shortLinkUrl
      totalHit
      isVisible
    }
  }
`;

export const setLinkVisibilityQuery = gql`
  mutation SetLinkIsVisible($id: ID!, $isVisible: Boolean!) {
    SetLinkIsVisible(input: { id: $id, isVisible: $isVisible }) {
      id
      isVisible
    }
  }
`;

export const removeLinkQuery = gql`
  mutation RemoveLink($id: ID!) {
    RemoveLink(input: { id: $id })
  }
`;

export const getPageLinkByShortLinkQuery = gql`
  query PageLinkByShortLink($pageName: String!, $shortLink: String!) {
    PageLinkByShortLink(input: { pageName: $pageName, shortLink: $shortLink }) {
      type
      page {
        fullname
        avatar {
          url
          thumbnailUrl
        }
      }
      link {
        url
      }
      product {
        id
        code
        title
        description
        shortLinkUrl
        images {
          id
          url
          thumbnailUrl
        }
        isAvailable
        category {
          id
          title
        }
        price
        discount
        links {
          id
          title
          url
          logoName
          shortLinkUrl
        }
      }
      post {
        id
        title
        description
        shortLinkUrl
        images {
          id
          url
          thumbnailUrl
        }
        category {
          id
          title
        }
        links {
          id
          title
          url
          logoName
          shortLinkUrl
        }
      }
    }
  }
`;

export const reorderLinkQuery = gql`
  mutation ReorderLink($id: ID!, $newOrder: Int!) {
    ReorderLink(input: { id: $id, newOrder: $newOrder })
  }
`;

export const batchNewExternalLinksQuery = gql`
  mutation BatchNewExternalLinks($links: [BatchNewLinkInput]!) {
    BatchNewExternalLinks(input: $links) {
      id
      title
      url
      createDate
      logoName
      token
      shortLinkUrl
      totalHit
      isVisible
    }
  }
`;
